<script lang="ts">
    import SVGIcon from "$/components/SVGIcon.svelte";
    import DeleteDocumentDialog from "./DeleteDocumentDialog.svelte";
    import { createEventDispatcher } from "svelte";

    export let document;
    export let deleteDocumentId;

    const dispatch = createEventDispatcher();
</script>

<li class="pdf-recent-item-container">


    {#if deleteDocumentId === document.id}
        <DeleteDocumentDialog
            snippetCount={document.snippetCount}
            on:confirmDelete={() => dispatch("confirmDelete")}
            on:cancelDelete={() => dispatch("cancelDelete")}
        />

    {:else}
        <a on:click={() => dispatch("openDocument")} class="pdf-recent-item">
            <span class="pdf-recent-item__icon">
                <SVGIcon
                    name="document"
                    color="#d1d5db"
                    size="20"
                    height="20"
                    strokeWidth="1.5"
                />
            </span>
            <span class="pdf-recent-item__name">{document.name}</span>
            <button
                class="pdf-recent-item__delete"
                on:click|preventDefault|stopPropagation={() =>
                    dispatch("showDeleteDialog")}
            >
                <SVGIcon name="trash" strokeWidth="1.5" />
            </button>
        </a>
    {/if}
</li>

<style>
    .pdf-recent-item-container {
        @apply relative mb-1 transition-all;
    }
    .pdf-recent-item {
        @apply flex w-full cursor-pointer items-center gap-2 rounded-3xl border border-gray-200 bg-gray-50 p-1 text-gray-800 hover:bg-gray-100;
    }
    .pdf-recent-item__icon {
        @apply pl-2;
    }
    .pdf-recent-item__name {
        @apply w-full truncate;
    }
    .pdf-recent-item__delete {
        @apply rounded-full p-1 hover:bg-gray-300;
    }

    :global(.pdf-recent-item__delete svg) {
        @apply stroke-gray-300;
    }

    :global(.pdf-recent-item__delete:hover svg) {
        @apply stroke-gray-600;
    }
</style>